import {Directive, effect, ElementRef, HostListener, Input, Renderer2} from '@angular/core';
import {ProcessButtonService} from './services/process-button.service';

/**
 * Directive that binds an element to a ProcessButtonService button ID.
 * When the button has an active process, it:
 * - Adds a spinner icon before the text
 * - Adds the 'disabled' CSS class
 * - Blocks click events
 *
 * Usage:
 *   <a class="cl-a-btn" [processButton]="'start-' + host.instanceId" (click)="start()">Start</a>
 */
@Directive({
  selector: '[processButton]',
})
export class ProcessButtonDirective {
  @Input({required: true}) processButton!: string;

  private wasActive = false;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private processButtonService: ProcessButtonService,
  ) {
    effect(() => {
      this.processButtonService.version();
      this.update();
    });
  }

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    if (this.processButtonService.isActive(this.processButton)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  private update() {
    const active = this.processButtonService.isActive(this.processButton);

    if (active && !this.wasActive) {
      this.renderer.addClass(this.el.nativeElement, 'cl-a-spinner');
      this.renderer.addClass(this.el.nativeElement, 'disabled');
      this.wasActive = true;
    } else if (!active && this.wasActive) {
      this.renderer.removeClass(this.el.nativeElement, 'cl-a-spinner');
      this.renderer.removeClass(this.el.nativeElement, 'disabled');
      this.wasActive = false;
    }
  }
}
